export const AnchorType = Object.freeze({
	mention: 'mention',
	reaction: 'reaction',
});
